import Component_Sound_b1c9cbe9f2c0e2d194634832901bfcd3 from "../../../../content/examples/basic/sound/Sound";
import Devtool_Sound_b1c9cbe9f2c0e2d194634832901bfcd3 from "!!@devtool/loader!../../../../content/examples/basic/sound/Sound";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Sound_b1c9cbe9f2c0e2d194634832901bfcd3,
  Devtool_Sound_b1c9cbe9f2c0e2d194634832901bfcd3,
  DevTool,
  React
};